<template>
  <div id="sign_in">
    <van-nav-bar :title="$t('title.task')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24" class="sign_in_title">
        <van-col span="22" offset="1" class="sign_in_title_center">{{ $t('column.has_been_continuously_signed')}}</van-col>
        <van-col span="22" offset="1" class="sign_in_title_day"> {{ signin_count }} <span>{{ $t('other.day')}}</span> </van-col>
      </van-col>
      <van-col span="24" class="sign_in_day">
        <van-col span="22" offset="1">
            <van-col :span="i === 6 ? 12 : 6" v-for="(item,i) in list" :key="i" class="sign_in_day_type">
              <van-col span="22" offset="1" :class="day_index >=i ? 'sign_in_day_type_bg_active' : 'sign_in_day_type_bg'">
                <van-col span="24" class="sign_in_day_type_bg_title"> {{item.day}} {{ $t('other.day')}}</van-col>
                <van-col span="24" class="sign_in_day_type_bg_sum">
                  <van-col span="24" class="sign_in_day_type_bg_sum_img"> <img src="../assets/img/coin11.png"/> </van-col>
                  <van-col span="24" class="sign_in_day_type_bg_sum_number">+ {{ item.num }}</van-col>
                </van-col>
              </van-col>
            </van-col>
        </van-col>
        <van-col span="20" offset="2" class="sign_in_day_btn2" v-if="today_signin"> {{ $t('column.check_in') }} </van-col>
        <van-col span="20" offset="2" class="sign_in_day_btn" @click.native="sign_in_btn" v-else> {{ $t('column.check_in') }} </van-col>

      </van-col>
       <van-col span="24" class="sign_in_vip_task">
         <van-col span="22" offset="1" class="sign_in_task_title">{{ $t('column.vip_tasks') }}</van-col>
          <van-col span="22" offset="1">
          <van-col span="24" class="sign_in_task_list_type">
            <van-col span="4" class="sign_in_task_list_img">
              <img src="../assets/img/vip/vip_task.png"/>
            </van-col>
            <van-col span="15" class="sign_in_task_list_center">
              <van-col span="24" class="sign_in_task_list_center_name">{{ $t('column.vip_daily_rewards') }}</van-col>
               <van-col span="24" class="sign_in_task_list_center_img">
                 <img src="../assets/img/vip/vip_task_icon.png"/>
               </van-col>
              <van-col span="24" class="sign_in_task_list_center_sum">
              <span v-if="vip_status== 0">{{ $t('column.lowest_reward') }} </span>  {{ vip_reward }} <img src="../assets/img/coin11.png"/>
              </van-col>
            </van-col>
            <van-col span="5" class="sign_in_task_list_btn">
              <van-button color="#CCCCCC" round block  size="small" v-if="vip_status == 1">{{ $t('column.Approved')}}</van-button>
              <van-button color="#F85F33" round block  size="small" @click="ClaimSvipBtn()" v-else-if="vip_status == 2">{{ $t('column.claim')}}</van-button>
              <van-button color="linear-gradient(to right, #f45ef3, #F85F33)" @click="ClaimSvipJump()" :icon="require('../assets/img/vip/vip_jump.png')" round block  size="small" v-else>VIP</van-button>
            </van-col>
          </van-col>
        </van-col>
       </van-col>
      <van-col span="24" class="sign_in_task">
        <van-col span="22" offset="1" class="sign_in_task_title">{{ $t('column.daily_tasks') }}</van-col>
        <van-col span="22" offset="1">
          <van-col span="24" v-for="(t,j) in task_list" :key="j" class="sign_in_task_list_type">
            <van-col span="4" class="sign_in_task_list_img">
              <img src="../assets/img/login_img.png" v-if="t.type === 0"/>
              <img src="../assets/img/game_img.png" v-else-if="t.type === 1"/>
              <img src="../assets/img/reward_anchor_img.png" v-else-if="t.type === 2"/>
              <img src="../assets/img/share_img.png" v-else-if="t.type === 3"/>
              <img src="../assets/img/follow_img.png" v-else/>
            </van-col>
            <van-col span="15" class="sign_in_task_list_center">
              <van-col span="24" class="sign_in_task_list_center_name">{{ t.title }}<span v-if="t.type !== 0">({{ t.current }}/{{ t.target }})</span></van-col>
              <van-col span="24" class="sign_in_task_list_center_sum">
                {{ t.money }} <img src="../assets/img/coin11.png"/>
              </van-col>
            </van-col>
            <van-col span="5" class="sign_in_task_list_btn">
              <van-button color="#CCCCCC" round block  size="small" v-if="t.left_times === 0">{{ $t('column.finish')}}</van-button>
              <van-button color="#AE2CF1" round block  size="small" @click="ClaimBtn(t)" v-else-if="t.current === t.target">{{ $t('column.claim')}}</van-button>
              <van-button color="#AE2CF1" round block  @click="task_btn(t)" size="small" v-else>{{ $t('column.undone') }}</van-button>
            </van-col>
          </van-col>
        </van-col>

      </van-col>
      <van-popup v-model="sign_show" class="sign_in_popup">
        <van-col span="24" class="sign_in_popup_title">{{ $t('column.check_in_successful') }}</van-col>
        <van-col  span="20" offset="2">
          <van-col span="24" class="sign_in_popup_coin_img"><img src="../assets/img/coin11.png"/> </van-col>
          <van-col span="24" class="sign_in_popup_coin"> + {{ reward }}</van-col>
        </van-col>
        <van-col span="20" offset="2" class="sign_in_popup_btn">
          <van-button round block color="linear-gradient(to top, #F639D0, #B21DFE)" @click="sign_show = false">{{ $t('column.got_it') }}</van-button>
        </van-col>
      </van-popup>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import Toast from 'vant/lib/toast'
import axios from "axios";

export default {
  data() {
    return {
      sign_show: false,
      sign_reward: 0,
      reward: 0,
      loading: false,
      signin_count: 0,
      today_signin: false,
      list:[],
      day_index: 0,
      task_list:[],
      vip_status: 0,
      vip_reward: 0,
    }
  },
  created() {
    this.get_list()
    this.get_task_list()
    this.get_svip()
  },
  methods: {
    ClaimSvipJump(){
      // 点击跳转vip--拦截
      window.location.href="live://live?action=JumpSvip"
    },
    ClaimSvipBtn(){
      // 点击领取
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=svip&act=claim_svip_daily_task",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.get_svip()
        }else{
          Toast(res.data.error)
        }
      })
    },
    get_svip(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=svip&act=get_daily_task_info",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.vip_status = res.data.data.vip_status
          this.vip_reward = res.data.data.daily_benefits
        }
      })
    },
    get_list() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=index&act=signin_list",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.list = res.data.list
          this.signin_count = res.data.signin_count
          this.today_signin = res.data.today_signin
        }
      })
    },
    get_task_list(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=mission&act=getMissionList",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.task_list = res.data.list
        }
      })
    },
    ClaimBtn(t) {
      // 点击领取
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=mission&act=commitMission",{ params:{ uid: uid, token: token,type: t.type }}).then(res =>{
        console.log(res.data)
        this.loading = false
        if(res.data.status===1){
          this.get_task_list()
        }else{
          Toast(res.data.error)
        }
      })
    },
    task_btn(t){
        // 点击去执行  -- 手机端拦截跳转 任务类型：0在线任务,1玩游戏任务,2打赏主播任务,3分享主播任务,4关注主播任务
        if(t.type === 1) {
          window.location.href="live://live?action=GameTask"
        }else if(t.type === 2) {
          window.location.href="live://live?action=RewardTask"
        }else if(t.type === 3) {
          window.location.href="live://live?action=ShareTask"
        }else if(t.type === 4) {
          window.location.href="live://live?action=FollowTask"
        } else{
          window.location.href="live://live?action=OnlineTask"
        }
    },
    sign_in_btn(){
      this.loading = true
      // 签到
      this.reward = undefined
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=index&act=user_signin",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        this.loading = false
        if(res.data.status===1){
          this.reward = res.data.reward
          this.sign_show = true
          this.get_list()
        }else{
          Toast(res.data.error)
        }
      })
    },
    // 返回上一页
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    }
  }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/sign_in.vue